import { cn } from '@/lib/utils'

/** A small ring that fills with the share of tutorials finished. */
export function TutorialProgressRing({
  done,
  total,
  className,
}: {
  done: number
  total: number
  className?: string
}) {
  const r = 8
  const c = 2 * Math.PI * r
  const share = total > 0 ? Math.min(1, done / total) : 0
  return (
    <svg className={cn('shrink-0 -rotate-90', className)} viewBox="0 0 20 20" aria-hidden>
      <circle
        cx={10}
        cy={10}
        r={r}
        fill="none"
        strokeWidth={2.5}
        className="stroke-current opacity-25"
      />
      {share > 0 ? (
        <circle
          cx={10}
          cy={10}
          r={r}
          fill="none"
          strokeWidth={2.5}
          strokeLinecap="round"
          strokeDasharray={c}
          strokeDashoffset={c * (1 - share)}
          className="stroke-ox-cyan transition-[stroke-dashoffset] duration-500"
        />
      ) : null}
    </svg>
  )
}
